import { useLazyQuery } from "@apollo/client/react";import React, { useMemo, useEffect, useState } from 'react';

import DataGridGenerico from '../../../components/dataGrid/DataGridGenerico';
import { generateColumnsDefaultConfiguration } from '../../../components/dataGrid/columnHelpers';
import { TextInput } from '../../../components/textInput/TextInput';
import { useDebounce } from '../../../hooks/useDebounce';
import { ButtonOptionGroup } from '../../../components/buttonOptionGroup/ButtonOptionGroup';
import { PopoverModal } from '../../../components/popoverModal/PopoverModal';
import { useNavigate } from 'react-router-dom';
import { adaptValidarInsumoArray, adaptValidarInsumoExportArray } from '../../../adapters/validarInsumoAdapter';
import { adaptValidarInsumoDetalle } from '../../../adapters/validarInsumoDetalleAdapter';
import { GET_VALIDAR_INSUMO_PAGINATED } from '../../../data/graphQL/queries/Insumos/getAllInsumos';
import { GET_INSUMO_DETALLE } from '../../../data/graphQL/queries/Insumos/getInsumoDetalle';
import './insumoValidateContent.scss';
import { useLocation } from 'react-router-dom';
import CheckIcon from '@mui/icons-material/Check';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import { usePersistFilters } from '../../../hooks/usePersistFilters';
import { CustomButton } from '../../../components/customButton/CustomButton';
import { GET_VALIDAR_INSUMO_FOR_EXPORT } from '../../../data/graphQL/queries/Insumos/getAllInsumosForExport';
import { downloadExcel } from '../../../utils/downloadExcel';

export const InsumoValidateContent = ({ setChildrenAction }) => {

  const navigate = useNavigate();
  const location = useLocation();

  const header = ["Insumo", "Descripción", "Activo", "Validado"];
  const FILE_TYPE = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
  const [allowedWrite, setAllowedWrite] = useState(false);

  const {
    rowsForExport,
    rows,
    insumosLoading,
    handleChangePaginationStatus,
    paginationStatus,
    totalCount,
    filters,
    handleChangeFilters
  } = useInsumos();

  const rutasStorage = localStorage.getItem('navigationRoutes');

  useEffect(() => {
    if (rutasStorage) {
      const rutas = JSON.parse(rutasStorage);
      const rutaQueSirve = location.pathname;

      setAllowedWrite(rutas?.find((ruta) => ruta.aplicaciones.find((app) => app.url == rutaQueSirve)
      )?.aplicaciones?.find((app) => app.url == rutaQueSirve).escritura);

    }
  }, [rutasStorage]);

  const handleExportar = () => {
    const dataExport = [];

    for (var i = 0; i < rowsForExport?.length; i++) {
      let nodo = rowsForExport[i];
      dataExport.push({
        idInsumo: nodo.idInsumo,
        descripcion: nodo.descripcion,
        activo: nodo.activo == 1 ? "SI" : "",
        validado: nodo.validado ? "SI" : ""
      });
    }

    if (dataExport.length > 0) {
      downloadExcel({
        fileName: 'ValidarInsumos',
        sheet: "Insumos",
        tablePayload: {
          header,
          body: dataExport
        }
      });
    }
  };

  useEffect(() => {
    setChildrenAction(() =>
    <div className='top-buttons'>
                <CustomButton
        className='margin-right'
        onClick={handleExportar}>
        
                    Exportar
                </CustomButton>
            </div>
    );
  }, [setChildrenAction, allowedWrite, rowsForExport]);

  const [action, setAction] = useState(false);
  const [getInsumoDetalle, { data: insumoFullData, loading: insumoDetalleLoading }] = useLazyQuery(GET_INSUMO_DETALLE, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!insumoFullData) return;
    navigate('/validarInsumo/insumo',
    {
      state: {
        Insumo: adaptValidarInsumoDetalle(insumoFullData.insumoRenderById),
        AllowedWrite: action
      }
    });
  }, [insumoFullData]);   

  const handleClickVerInsumo = async (insumo, permiso) => {
    setAction(permiso);
    if (!insumoDetalleLoading) {
      getInsumoDetalle({ variables: { idInsumoN: insumo.idInsumoN } });
    }
  };

  const initialColumns = [
  {
    headerName: '',
    field: 'action',
    flex: 0.05,
    renderCell: (cellProps) => {
      const { row } = cellProps;
      return (
        <>
                        <PopoverModal>
                            <div className='popover-modal-content'>
                                {
              allowedWrite && //solo puede aprobar si tiene permiso
              <div
                onClick={() => handleClickVerInsumo(row, true)} aria-hidden='true'
                className='item-option clickable-option'>
                
                                        <EditIcon className='edit-icon' />
                                        <span className='toggle-action'>Editar</span>
                                    </div>
              }

                                <div
                onClick={() => handleClickVerInsumo(row, false)} aria-hidden='true'
                className='item-option clickable-option'>
                
                                    <VisibilityIcon className='edit-icon' />
                                    <span className='toggle-action'>Ver</span>
                                </div>


                            </div>
                        </PopoverModal>
                    </>);

    }
  },
  {
    field: 'idInsumo',
    headerName: 'Insumo'
  },
  {
    field: 'descripcion',
    headerName: 'Descripción',
    flex: 0.8
  },
  {
    field: 'activo',
    type: 'boolean',
    headerName: 'Activo',
    headerAlign: 'center',
    align: 'center',
    flex: 0.1,
    renderCell: (params) => {
      return params.value ?
      <CheckIcon
        className='icon-grid' /> :

      "";
    }
  },
  {
    field: 'validado',
    type: 'boolean',
    headerName: 'Validado',
    headerAlign: 'center',
    align: 'center',
    flex: 0.1,
    renderCell: (params) => {
      return params.value ?
      <CheckIcon
        className='icon-grid' /> :

      "";
    }
  }];


  const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns), null);

  return (
    <div className='general-container'>
            <div className='action-row'>
                <TextInput
          placeholder='Filtrar'
          value={filters?.searchFilter}
          width='30%'
          searchIcon
          onChange={(e) => handleChangeFilters('searchFilter', e.target.value)}
          onClearButtonClick={() => handleChangeFilters('searchFilter', '')} />
        
                <div className='button-group-container'>
                    <ButtonOptionGroup
            options={['Activos', 'Inactivos', 'Todos']}
            onOptionClick={(v) => handleChangeFilters('selectedFilterByStatus', v)}
            selectedOption={filters?.selectedFilterByStatus} />
          
                </div>
                <div className='button-group-container'>
                    <ButtonOptionGroup
            options={['Validados', 'No validados']}
            onOptionClick={(v) => handleChangeFilters('selectedFilterByValidate', v)}
            selectedOption={filters?.selectedFilterByValidate} />
          
                </div>
            </div>
            <DataGridGenerico
        columns={columns}
        rows={rows}
        toolbar={false}
        loading={insumosLoading}
        onPageChange={(page) =>
        handleChangePaginationStatus((prev) => ({
          ...prev,
          page: page
        }))
        }
        onPageSizeChange={(pageSize) =>
        handleChangePaginationStatus((prev) => ({
          ...prev,
          pageSize: pageSize,
          page: 0
        }))
        }
        pageSize={paginationStatus.pageSize}
        totalCount={totalCount}
        currentPage={paginationStatus.page} />
      
        </div>);

};


const useInsumos = () => {
  const [Insumos, setInsumos] = useState([]);
  const [insumosForExport, setInsumosForExport] = useState([]);

  const [paginationStatus, setPaginationStatus] = useState({
    pageSize: 10,
    page: 0
  });

  const filtros = JSON.parse(localStorage.getItem('validarInsumoFilters'));
  const { filters, handleChangeFilters } = usePersistFilters(
    {
      searchFilter: filtros != null ? filtros.searchFilter : "",
      selectedFilterByStatus: filtros != null ? filtros.selectedFilterByStatus : 0,
      selectedFilterByValidate: filtros != null ? filtros.selectedFilterByValidate : 0
    },
    'validarInsumoFilters'
  );

  const {
    searchFilter,
    selectedFilterByStatus,
    selectedFilterByValidate
  } = filters;

  const debouncedFilterValue = useDebounce(searchFilter, 1000);

  const [getInsumos, { data: insumosData, loading: insumosLoading }] = useLazyQuery(GET_VALIDAR_INSUMO_PAGINATED, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!insumosData) return;
    setInsumos(insumosData);
  }, [insumosData]);  

  const [getInsumosForExport, { data: insumosDataExport, loading: insumosExportLoading }] = useLazyQuery(GET_VALIDAR_INSUMO_FOR_EXPORT, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!insumosDataExport) return;
    setInsumosForExport(adaptValidarInsumoExportArray(insumosDataExport?.allValidarInsumoForExport));
  }, [insumosDataExport]);  

  useEffect(() => {
    if (!insumosLoading) {
      getInsumos({
        variables: {
          skip: paginationStatus.page * paginationStatus.pageSize,
          take: paginationStatus.pageSize,
          where: {
            or: [
            { idInsumo: { contains: debouncedFilterValue?.trim() } },
            { descripcion: { contains: debouncedFilterValue?.trim() } }],

            and: [
            { motivoValidacion: { in: [null, ''] } },
            selectedFilterByStatus < 2 ? { activo: { eq: selectedFilterByStatus == 1 ? 0 : 1 } } : {},
            { validado: { eq: !Boolean(selectedFilterByValidate) } }]

          },
          order: { idInsumo: "ASC" }
        }
      });
    }
    if (!insumosExportLoading) {
      getInsumosForExport({
        variables: {
          where: {
            or: [
            { idInsumo: { contains: debouncedFilterValue?.trim() } },
            { descripcion: { contains: debouncedFilterValue?.trim() } }],

            and: [
            selectedFilterByStatus < 2 ? { activo: { eq: selectedFilterByStatus == 1 ? 0 : 1 } } : {},
            { validado: { eq: !Boolean(selectedFilterByValidate) } }]

          },
          order: { idInsumo: "ASC" }
        }
      });
    }
  }, [selectedFilterByStatus, selectedFilterByValidate, paginationStatus, debouncedFilterValue]);

  return {
    rowsForExport: insumosForExport,
    rows: adaptValidarInsumoArray(Insumos) || [],
    insumosLoading,
    handleChangePaginationStatus: setPaginationStatus,
    paginationStatus,
    totalCount: Insumos?.allValidarInsumo?.totalCount,
    filters,
    handleChangeFilters
  };
};